import { z } from 'zod';
import { createVendorSchema } from './vendor';

const pickFromRolodex = z.object({
  mode: z.literal('pick'),
  vendorId: z.string().uuid(),
  primaryContactId: z.string().uuid().optional().nullable(),
  role: z.string().max(100).optional().nullable(),
  notes: z.string().max(2000).optional().nullable(),
});

const createNew = z.object({
  mode: z.literal('create'),
  vendor: createVendorSchema,
  role: z.string().max(100).optional().nullable(),
  notes: z.string().max(2000).optional().nullable(),
});

export const createProjectVendorSchema = z.discriminatedUnion('mode', [pickFromRolodex, createNew]);

export const updateProjectVendorSchema = z.object({
  primaryContactId: z.string().uuid().optional().nullable(),
  role: z.string().max(100).optional().nullable(),
  notes: z.string().max(2000).optional().nullable(),
});

export type CreateProjectVendorInput = z.infer<typeof createProjectVendorSchema>;
export type UpdateProjectVendorInput = z.infer<typeof updateProjectVendorSchema>;
